import React, { useEffect, useState } from "react";
import styles from "./ekyc.module.scss";

const EkycSettings = ({ token }) => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
  }, []);
  return (
    <div className={styles.ekycWrapper}>
        <h5>Ekyc Settings</h5>
    </div>
  );
};

export default EkycSettings;
